var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"py-6 justify-start",on:{"click":_vm.connect}},[_c('v-img',{staticClass:"mr-2 flex-grow-0",attrs:{"src":_vm.KindTypeIcon.linkedinPost,"width":"30","height":"30"}}),_vm._v(" "+_vm._s(_vm.$t('buttons.social-media.connect-linkedin'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }